import React from 'react'
import './Education.css'
import PlaceTwoToneIcon from '@material-ui/icons/PlaceTwoTone';
function Education() {
  return (
    <div className="container">
    <div className="education">
      <div className="education_primary">
        <h1>Primary</h1>
        <div className="education_name">
           <h2>School</h2>
           <h4>Modern alpha high Secondary,School</h4>
           <h2><PlaceTwoToneIcon/>Place</h2>
           <h4>Chhabra,Rajasthan</h4>
           <h2>Score</h2>
              <h4>62%</h4>
        </div>
      </div>


          <div className="education_primary">
            <h1>Secondary</h1>
            <div className="education_name">
               <h2>School</h2>
               <h4>JBS children paradise,school</h4>
               <h2><PlaceTwoToneIcon/>Place</h2>
               <h4>Kota,Rajasthan</h4>
               <h2>Score</h2>
                  <h4>62.5%</h4>

            </div>
          </div>


              <div className="education_primary">
               <h1>Graduation</h1>
               <div className="education_name">
                  <h2>College</h2>
                  <h4>Global institute of technology,Jaipur</h4>
                  <h2><PlaceTwoToneIcon/>Place</h2>
                  <h4>Jaipur,Rajasthan</h4>
                  <h2>Score</h2>
                     <h4>62%</h4>

               </div>

              </div>
                </div>

      </div>

  )
}

export default Education
